import {useEffect} from 'react';
import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {useWindowDimensions} from 'react-native';
import {useModalUpsellProTrial} from 'interface/hooks/useModalUpsellProTrial';
import {useModal} from 'extensions/viewport/useModal';
import storage from 'extensions/storage';
import {isTouch, isPreview, isLocal} from 'utils/platform';
import {WelcomeModal} from 'interface/stacks/Welcome';
import {name} from 'config/app';
import * as app from 'store/slices/app';

export function useWelcome(isLoggedIn: boolean) {
  const screen = useWindowDimensions();
  const isTrial = useSelector(app.selectors.isTrial);
  const isPremium = useSelector(app.selectors.isPremium);
  const isBusiness = useSelector(app.selectors.isBusiness);
  const hasTrialDialog = !isTouch() && !isPreview() && !isLocal() && !isPremium && !isTrial && screen.width > 600;
  const hasWelcomeDialog = false; // !isTouch() && screen.width >= 800;
  const hasFullDialog = screen.width > 600;
  const modal = useModal();
  const [showTrialSignup] = useModalUpsellProTrial();
  const welcome = useCallback(() => modal.open(
    <WelcomeModal
      exit={modal.exit}
      isBusiness={isBusiness}
      isMinimal={!hasFullDialog}
    />), [isBusiness, hasFullDialog]);

  useEffect(() => {
    try {
      if (!isLoggedIn) return;
      const db = storage.init(name);
      Promise.all([
        db.getItem('welcome:shown'),
        db.getItem('upsell:trial'),
      ]).then(([welcomeShown, upsellTrial]) => {
        try {
          if (hasWelcomeDialog && welcomeShown !== '1') {
            welcome();
          } else if (hasTrialDialog && upsellTrial !== '1') {
            showTrialSignup();
          }
        } catch (e) {}
      });
    } catch (e) {}
  }, []);
}
